import React, { useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';

import 'react-dropdown-tree-select/dist/styles.css'
import swal from 'sweetalert';
import $ from 'jquery';

import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { HomeIcon } from '../../assets/Icons';


var imgPrefix = `${SERVER_IP}/icons`
class EditUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Lists: {},
            user_action: "view",
            tempList: {},
            image: "",
            temp_image: ""
        }
    }


    viewInfo = () => {
        var data = {
            s_id: "",
            user_id: ud.id,
            user_type: ud.usertype
        }
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/usersList`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error == false) {
                    if (response.data.usersList) {
                        if (response.data.usersList.length == 1) {
                            _this.setState({ Lists: JSON.parse(JSON.stringify(response.data.usersList[0])), tempList: response.data.usersList[0], message: response.data.usersList.length === 0 ? "No Record Found." : "" });
                        }
                    }

                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.viewInfo();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    componentDidMount() {
        this.viewInfo();

        // this.getTotalType()
        var current = this
        $(".btnrating").on('click', (function (e) {

            var previous_value = $("#selected_rating").val();

            var selected_value = $(this).attr("data-attr");
            current.setState({ rating: selected_value })
            $("#selected_rating").val(selected_value);

            $(".selected-rating").empty();
            $(".selected-rating").html(selected_value);

            for (var i = 1; i <= selected_value; ++i) {
                $("#rating-star-" + i).toggleClass('btn-warning');
                $("#rating-star-" + i).toggleClass('btn-default');
            }

            for (var ix = 1; ix <= previous_value; ++ix) {
                $("#rating-star-" + ix).toggleClass('btn-warning');
                $("#rating-star-" + ix).toggleClass('btn-default');
            }

        }));
    }
    getTotalType = () => {
        var data = {
            jwt: jwt,
            s_id: ud.main_id
        }
        let _this = this;
        var heirarchy = this.state.heirarchy
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/view/typesfordropdown`, data, { withCredentials: true, headers: headers })
            .then(function (response) {

                if (response.data.error === false) {

                    var r = _this.convert(response.data.result.result)
                    // var r = _this.convert(heirarchy)
                  
                    var temparr = [];
                    r.map((list, index) => { temparr.push([]) })
                    _this.setState({ typeHierarchy: r, dynamicSelectedType: temparr });

                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getTotalType();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    onChangeDropdownDepartment = (currentNode, selectedNodes) => {

        this.setState({ departmentSelected: selectedNodes })
    }
    onChangeDropdownEquipment = (currentNode, selectedNodes) => {
        this.setState({ equipmentSelected: selectedNodes })

    }
    onChangeDropdownUnit = (currentNode, selectedNodes) => {
        this.setState({ unitSelected: selectedNodes })
    }
    onAction = (node, action) => {
        // console.log('onAction::', action, node)
    }
    onNodeToggle = currentNode => {
        // console.log('onNodeToggle::', currentNode)
    }
    onChangeDropdown = (index, currentNode, selectedNodes) => {
     
        this.state.dynamicSelectedType[index] = selectedNodes;
        this.setState(this.state)
    }
    onChangeInput = (e) => {
        e.preventDefault();
        this.state.tempList[e.target.name] = e.target.value
        this.setState(this.state)
    }
    Edit = () => {
        var data = {
            name: this.state.tempList.name,
            phone: this.state.tempList.phone,
            // type_id: filteredSelectedTypes,
            status: this.state.Lists.status,
            usertype: this.state.Lists.usertype,
            address: this.state.tempList.address,
            id: this.state.Lists.login_id,
            new_profile: this.state.image,
            old_profile: this.state.Lists.profile,
            city: this.state.tempList.city,
            state: this.state.tempList.state,
            zip: this.state.tempList.zip,
            designation: this.state.Lists.designation,
            uniqueID: this.state.Lists.uniqueID,
            main_status: this.state.Lists.mainStatus,
            cropperOn: false,
            user_update_status: {
                name: this.state.tempList.name == this.state.Lists.name ? "0" : "1",
                phone: this.state.tempList.phone == this.state.Lists.phone ? "0" : "1",
                usertype: "0",
                profile: this.state.image == "" ? "0" : "1",
                address: this.state.tempList.address == this.state.Lists.address ? "0" : "1",
                city: this.state.tempList.city == this.state.Lists.city ? "0" : "1",
                state: this.state.tempList.state == this.state.Lists.state ? "0" : "1",
                zip: this.state.tempList.zip == this.state.Lists.zip ? "0" : "1",
                types: "0"
            }
        }
        var _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/create/user_edit`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.error == false) {
                        swal(response.data.message)
                        _this.viewInfo();
                        _this.setState({ user_action: "view" });
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.Edit();
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong. Please Retry.")
            });
    }
    handleImageChange = (e) => {
        e.preventDefault();
        if (!e.target.files[0]) {
            return
        }
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            this.setState({
                temp_image: reader.result,
                cropperOn: true
            });

        };
    }

    _crop() {
        // image in dataUrl
        // console.log(this.cropper.getCroppedCanvas().toDataURL());
    }
    getImage = () => {
       this.setState({ image: this.cropper.getCroppedCanvas({ 'width': 200, 'height': 200 }).toDataURL(), cropperOn: false })
    }
    onCropperInit(cropper) {
        this.cropper = cropper;
    }
    render() {

        return (
            <div>
                <div class="xp-breadcrumbbar">
                    <div class="row">
                        <div className="col-md-6">
                            <h4 className="xp-page-title">User Profile</h4>
                        </div>
                        <div class="col-md-12 col-lg-12">
                            <div class="xp-breadcrumb gradient-border"> 
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><HomeIcon/> </a></li>
                                    <li class="breadcrumb-item active">User Profile</li>
                                </ol>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6 mt-4">
                            {this.state.user_action != "edit" ?
                                <button className="newbtnstyle" title="Create new" onClick={() => this.setState({ user_action: "edit" })}><i className="mdi mdi-plus"></i>Edit User</button>
                                :
                                <button className="newbtnstyle" title="Create new" onClick={() => this.setState({ user_action: "view" })}><i className="mdi mdi-plus"></i>View User</button>
                            }
                        </div>
                    </div>

                    {this.state.user_action != "edit" ?
                        <div className="xp-contentbar">
                            <div className="row">
                                <div className="">
                                    <div className="card m-b-30">
                                        <div className="card-header ">
                                            <h5 className="card-title">User Profile</h5>
                                        </div>
                                        <div className="card-body">
                                            <div class="xp-social-profile-middle text-center">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="xp-social-profile-avatar text-center">
                                                            <img src={`${imgPrefix}/${this.state.Lists.profile}`} alt="user-profile" class="rounded-circle img-fluid" style={{ height: "200px" }} />
                                                        </div>
                                                        <div class="xp-social-profile-title">
                                                            <h5 class="my-1 text-black">{this.state.Lists.name}</h5>
                                                        </div>
                                                        <div class="xp-social-profile-subtitle">
                                                            <p class="mb-3 text-muted">{this.state.Lists.designation}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <ul className="profile-list">
                                                <li><label>Name</label><p>{this.state.Lists.name}</p></li>
                                                <li><label>Email</label><p>{this.state.Lists.email}</p></li>
                                                <li><label>Phone</label><p>{this.state.Lists.phone}</p></li>
                                                <li><label>Address</label>{this.state.Lists.address}<p></p></li>
                                                <li><label>City</label><p>{this.state.Lists.city}</p></li>
                                                <li><label>State</label><p>{this.state.Lists.state}</p></li>
                                                <li><label>ZIP</label><p>{this.state.Lists.zip}</p></li>
                                                <li><label>User Type</label><p>{this.state.Lists.user_type}</p></li>
                                                <li><label>Designation</label><p>{this.state.Lists.designation}</p></li>
                                                <li><label>ID</label><p>{this.state.Lists.uniqueID}</p></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="card-body m-b-30">
                            <div className="form-group">
                                <label for="exampleInputEmail1">User Name</label>
                                <input type="text" onChange={this.onChangeInput} name="name" className="form-control" value={this.state.tempList.name} placeholder="Enter Site Name" />

                            </div>
                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label for="exampleInputEmail1">Phone</label>
                                    <input type="text" onChange={this.onChangeInput} name="phone" value={this.state.tempList.phone} className="form-control" placeholder="Enter Phone" />
                                </div>
                                <div className="form-group col-md-6">
                                    <label for="exampleInputEmail1">Profile Image</label>
                                    <div className="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i className="mdi mdi-file-image"></i></span>
                                        </div>
                                        <input type="file" onChange={this.handleImageChange} name="logo" className="form-control" placeholder="Upload Image" accept="image/*" />
                                    </div>

                                </div>
                            </div>

                            {this.state.cropperOn ?
                                <div id="popup" class="overlay">
                                    <div class="modal-dialog modal-xl">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title" id="exampleStandardModalLabel">Image Crop</h5>
                                                <button type="button" class="close" onClick={() => this.setState({ cropperOn: false })}>
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                            </div>
                                            <div class="modal-body">
                                                <Cropper
                                                    src={this.state.temp_image}
                                                    style={{ height: 400, width: '100%' }}
                                                    // Cropper.js options
                                                    // initialAspectRatio={1 / 1}
                                                    aspectRatio={1 / 1}
                                                    guides={false}
                                                    crop={this._crop.bind(this)}
                                                    onInitialized={this.onCropperInit.bind(this)}
                                                    zoomable={false}
                                                    // background={false}
                                                    viewMode={1}
                                                />

                                                <div className="body-footer mt-3">
                                                    <div className="text-right">
                                                        <button type="submit" onClick={this.getImage} className="btn btn-primary">Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                : null}












                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label for="exampleInputEmail1">City</label>
                                    <input type="text" onChange={this.onChangeInput} name="city" value={this.state.tempList.city} className="form-control" placeholder="Enter City Name" />
                                </div>
                                <div className="form-group col-md-4">
                                    <label for="exampleInputEmail1">State</label>
                                    <input type="text" onChange={this.onChangeInput} name="state" value={this.state.tempList.state} className="form-control" placeholder="Enter State Name" />
                                </div>
                                <div className="form-group col-md-2">
                                    <label for="exampleInputEmail1">ZIP</label>
                                    <input type="text" onChange={this.onChangeInput} name="zip" value={this.state.tempList.zip} className="form-control" placeholder="Enter ZIP" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label for="exampleInputEmail1">Address</label>
                                <input type="text" onChange={this.onChangeInput} name="address" value={this.state.tempList.address} className="form-control" placeholder="Enter Address" />
                            </div>

                            <button type="submit" onClick={this.Edit} className="btn btn-primary">Save</button>
                        </div>
                    }
                </div>
            </div>


        )
    }
}
export default EditUser





const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
        (val) => val.length > 0 && (valid = false)
    );
    return valid;
}